import { Component, Input, ElementRef, ViewChild } from '@angular/core';
import { NotificationsService } from 'angular2-notifications';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { Log } from '../../../utils/index';
import { User, } from '../../../entities/index';
import { UserService } from '../../../services/user.service';
import { Api } from '../../../services/api.service';


@Component({
  selector: 'app-user-connect',
  template: `
    <a *ngIf="user && user.id" (click)="loadIframe()" class="btn btn-default pull-right margin-left" [ngClass]="{'disabled': iframeLoaded}">Auto connect</a>
    <iframe [hidden]="true" *ngIf="iframeLoaded" #iframe [src]="backendLogoutUrl"></iframe>
  `
})
export class UserConnectComponent {
  buttonDisabled = true;
  iframeLoaded = false;
  backendUrl: string;
  backendRedirectUrl: string;
  backendLogoutUrl: SafeResourceUrl;

  @Input()
  user: User;

  @ViewChild('iframe')
  iframe: ElementRef;

  constructor(protected api: Api,
              protected userService: UserService,
              protected notification: NotificationsService,
              protected sanitizer: DomSanitizer) {
    this.backendUrl = this.api.getBackendUrl();
    this.backendLogoutUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.backendUrl + '/fr/logout');
    this.backendRedirectUrl = this.backendUrl + '/fr/';
  }

  @Log()
  loadIframe() {
    // First add the iframe to the dom. It loads the /logout url to disconnect any user (cf template)
    if (this.iframeLoaded) {
      this.notification.error('ERROR', 'Unable to auto connect ...');
      return;
    }

    this.iframeLoaded = true;
    this.notification.info('INFO', 'Currently connecting to the backend. Wait a few seconds... ' +
      '!!!!IMPORTANT!!!! You need to authorize popup on your browser.', {timeOut: 4000});

      this.connectAndRedirect();
  }

  @Log()
  connectAndRedirect() {
    this.userService
      .createDebugPassword(this.user)
      .subscribe((password) => {
        const redirectUrl = this.backendUrl + '?mail=' + this.user.mail + '&pass=' + password;
          const newWindow = window.open(redirectUrl);
          if (!newWindow || newWindow.closed || typeof newWindow.closed === 'undefined') {
            this.notification.error('ERROR', 'Enable popup for this site in your browser, ' +
              'reload the page and try again');
          }
      });
  }
}



// WEBPACK FOOTER //
// /app/src/app/components/pages/user/user-connect.component.ts